import * as React from 'react';

function SvgFlowCascade(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 24" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M13 17.87a3 3 0 00-2.72 1.79H6.13a1.9 1.9 0 01-1.88-1.92v-4.91a4.24 4.24 0 001.88.45h4.15A3 3 0 0013 15.06a3.06 3.06 0 000-6.12 3 3 0 00-2.72 1.78H6.13a1.89 1.89 0 01-1.88-1.91v-3A3.06 3.06 0 006 3.06 3 3 0 003 0a3 3 0 00-3 3.06 3.06 3.06 0 001.75 2.78v11.9a4.42 4.42 0 004.38 4.47h4.15A3 3 0 0013 24a3.07 3.07 0 000-6.13zm0-7.64A1.77 1.77 0 1111.27 12 1.75 1.75 0 0113 10.23zM3 1.3a1.77 1.77 0 010 3.53 1.75 1.75 0 01-1.73-1.77A1.74 1.74 0 013 1.3zm10 21.4a1.77 1.77 0 111.73-1.76A1.74 1.74 0 0113 22.7z" />
    </svg>
  );
}

const MemoSvgFlowCascade = React.memo(SvgFlowCascade);
export default MemoSvgFlowCascade;
